module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/open/09053718299f63717111ae10cd344fe5.png";